import { styled } from '@mui/material/styles';
import { errorRed } from '@style/variables';

export const Container = styled('section')(
  ({ theme }) => `
  max-width: 762px;
  padding: ${theme.spacing(7)} ${theme.spacing(3)};
  margin: 0 auto;
  box-sizing: content-box;
`,
);

export const Form = styled('form')(
  ({ theme }) => `
  padding: 0;

  @media (min-width: 762px) {
    padding: 0 ${theme.spacing(16)};
  }
`,
);

export const FormError = styled('form')(
  ({ theme }) => `
  margin-top: ${theme.spacing(2)};
  color: ${errorRed};
`,
);
